import { render } from "./UserSimple.vue?vue&type=template&id=5ca1da6b"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/UserSimple.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ca1da6b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ca1da6b', __exports__)) {
    api.reload('5ca1da6b', __exports__)
  }
  
  module.hot.accept("./UserSimple.vue?vue&type=template&id=5ca1da6b", () => {
    api.rerender('5ca1da6b', render)
  })

}


export default __exports__